
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { UserInfoStore } from "../shared/store/userInfo.store";

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {

    loggedIn = false;
    cartItems = [];
    constructor(
      private infoStore: UserInfoStore,
      private router: Router,
      private itemModifierService: ItemModifierService
    ) {}
    getCartItems;
    total: number = 0;
    IDSS :number =0;

    ngOnInit() {

      this.FillCart();

      if( sessionStorage.getItem("ProceedPay_Id")=="1" ){

        this.infoStore.setCartInfo([]);
        sessionStorage.clear();
        this.infoStore.setInfo({});

       alert("Session Expired , Please Login  !!");
       this.router.navigateByUrl("login");

       }

    }


    FillCart(){

      if (sessionStorage.getItem("OrderMaster_Id")) {
        this.loggedIn = true;
        this.total = 0;
        this.itemModifierService
          .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
          .subscribe((event: any) => {
            if (event.length > 0) {

              this.cartItems = event;

                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }

              this.cartItems.forEach((item) => {
              
              this.total = this.total + item.Price * item.Qty;

              });
              } else {

              this.cartItems = [];
              this.total = 0;

            }
          });
      } else {
        
              this.loggedIn = false;
              this.cartItems = [];
              this.total = 0;
      }

    }


    loginredirect() {
      this.router.navigateByUrl("login");
    }
    homeRedirect() {
      this.router.navigateByUrl("home");
    }
    checkout() {
      this.router.navigateByUrl("checkout");
    }

    UpdateNow(Ids , qty){

      this.IDSS=Ids;

    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: this.IDSS,
        Qty:qty,
        //CreatedBy: Number(sessionStorage.getItem("UID")),
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        OperationType: "update",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Updated") {
            //alert("Add To Cart Successfully !");
            this.FillCart();
            this.getCartInfo();
          }
        }
      });
    } 
    else 
    {

      alert("Please Login");
      this.router.navigateByUrl("login");

    }



    }


    cancelCart( Ids){

    this.IDSS=Ids;

    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item = {
        Id: this.IDSS,
        CreatedBy: Number(sessionStorage.getItem("UID")),
        OperationType: "delete",
      };
      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);
          if (event[0].OperationStatus == "Successfully Deleted") {
            //alert("Add To Cart Successfully !");
            this.FillCart();
            this.getCartInfo();
          }
        }
      });
    } 
    else 
    {

      alert("Please Login");
      this.router.navigateByUrl("login");
      
    }

    }


    getCartInfo() {
      if (sessionStorage.getItem("OrderMaster_Id")) {
        this.itemModifierService
          .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
          .subscribe((event: any) => {
            if (event.length > 0) {
              this.infoStore.setCartInfo(event);
            } else {
              this.infoStore.setCartInfo([]);
            }
          });
      } else {
        this.infoStore.setCartInfo([]);
      }
    }

  }

